import MXCache from 'Common/CacheManager/MXCache';
import { AppMode } from 'Common/Enums/metadata.enum';
import {
    AuthResponse,
    UserAuthResponse,
} from 'Common/Models/authresponse.model';
import MXLogger from 'Common/MXLogger';
import { getMobileOSType } from 'Common/Utils/CheckDevice';
import { createStore, setMany, UseStore } from 'idb-keyval';
import {
    getMobileAuthCookie,
    getMobileAuthCookieFromCb,
    getPlatformNamefromCookie,
} from 'utils/getMobileCookies';
import {
    handleMobileExceptions,
    handleMobileToSetUserAuthToken,
} from 'utils/mobileCallbackHandle';
import API, { setUserAuthResponseToMXCache } from '../API';

export default class AuthService extends API {
    static authUrl = process.env.REACT_APP_AUTH_BASE_URL || '';

    static apiBaseUrl =
        `${process.env.REACT_APP_API_SERVICE_BASE_URL}auth/` || '';

    static RegionID = process.env.REACT_APP_REGION_ID || '1';

    clearInterval = 0;

    mode: number;

    authorization?: string | null;

    converseStore: UseStore;

    constructor(mode: number, authorization?: string) {
        super(AuthService.authUrl, false);
        this.mode = mode;
        this.authorization = authorization;

        this.converseStore = createStore('Converse_DB', 'Converse_Auth');
    }

    async isAuthorized(): Promise<boolean> {
        let authToken = API.GetAuthToken();
        MXLogger.debug(
            `isAuthorized called - Mode: ${this.mode}, AuthToken: ${authToken ? 'Present' : 'Missing'}, Authorization: ${this.authorization ? 'Present' : 'Missing'}`
        );

        if (this.mode === AppMode.LsqMobile && authToken === null) {
            let mobileUserData = '';
            const mobileAuthCookie = getMobileAuthCookie();
            const platFormNameFromCoookie =
                getPlatformNamefromCookie(mobileAuthCookie) ||
                getMobileOSType();
            const platFormName = getMobileOSType();
            if (
                platFormName === 'android' ||
                platFormNameFromCoookie === 'android'
            ) {
                mobileUserData = (
                    window as any
                ).LSQAndroidClient?.fetchConverseUserAuthResponse();
            } else if (
                platFormName === 'ios' ||
                platFormNameFromCoookie === 'ios'
            ) {
                const mobileUserDataPromise = (
                    window as any
                ).webkit?.messageHandlers?.fetchConverseUserAuthResponse?.postMessage(
                    'fetchConverseUserAuthResponse'
                );

                mobileUserData = await mobileUserDataPromise
                    .then((res: any) => res)
                    .catch((e: any) => '');
            }
            const userData = mobileUserData ? JSON.parse(mobileUserData) : null;

            if (
                userData &&
                userData.converseUserAuthResponse &&
                Object.keys(userData.converseUserAuthResponse).length > 0
            ) {
                const { converseUserAuthResponse } = userData;
                authToken = {
                    Token: (converseUserAuthResponse as UserAuthResponse).token,
                    ExpiresOn: (converseUserAuthResponse as UserAuthResponse)
                        .expiresOn,
                };
                API.SetAuthToken(authToken);
                setUserAuthResponseToMXCache(
                    converseUserAuthResponse as UserAuthResponse
                );
                MXCache.SetCacheItem(
                    MXCache.ConnectorConfigKey,
                    userData?.connectorConfigKey,
                    30
                );
            }
        }

        const Token = authToken?.Token;
        const ExpiresOn = authToken?.ExpiresOn;

        MXLogger.debug(
            `Token details - Token: ${Token ? 'Present' : 'Missing'}, ExpiresOn: ${ExpiresOn || 'Missing'}`
        );

        // set token in IDB
        setMany(
            [
                ['Token', Token],
                ['ExpiresOn', ExpiresOn],
            ],
            this.converseStore
        );

        if (!this.isValidJwtToken(Token)) {
            MXLogger.debug(
                'auth token is invalid or expired, checking for auth cookie. Token: ' +
                    Token
            );
            API.RemoveAuthToken();
            MXCache.RemoveOneItem(MXCache.UnreadChatCount);
            MXCache.RemoveOneItem(MXCache.Carter);
            return this.authorize(
                this.mode,
                this.authorization,
                AuthService.RegionID,
                this.converseStore,
                this.loopCheckToken
            );
        }

        if (!(await this.isauth())) {
            MXLogger.debug('is auth was not successfull');
            MXCache.RemoveOneItem(MXCache.UnreadChatCount);
            MXCache.RemoveOneItem(MXCache.Carter);
            return this.authorize(
                this.mode,
                this.authorization,
                AuthService.RegionID,
                this.converseStore,
                this.loopCheckToken
            );
        }

        return true;
    }

    private async isauth(): Promise<boolean> {
        // const dt = new Date();
        // if (
        //     [
        //         AppMode.Widget,
        //         AppMode.MarvinMobile,
        //         AppMode.MarvinWidget,
        //     ].includes(this.mode) &&
        //     new Date(tokenExpiry) > dt
        // ) {
        //     return true;
        // }
        const res = this.Responsify<any>(
            await new API(AuthService.apiBaseUrl, true, true).instance.get(
                'isauthorized',
                {
                    withCredentials: true,
                    headers: {
                        LSQ_RID: AuthService.RegionID,
                    },
                }
            )
        );
        if (!res) return false;
        this.loopCheckToken();
        return true;
    }

    private checkTokenExpiryAndAuthorize = async (authToken: AuthResponse) => {
        const dt = new Date();
        const extraTime = new Date(dt.getTime() + 3 * 60000);

        if (extraTime > new Date(authToken.ExpiresOn)) {
            MXLogger.debug('expired');
            API.RemoveAuthToken();

            await this.authorize(
                this.mode,
                this.authorization,
                AuthService.RegionID,
                this.converseStore,
                this.loopCheckToken
            );
        }
    };

    private loopCheckToken = () => {
        if (this.clearInterval === 0) {
            this.clearInterval = window.setInterval(async () => {
                const authToken = API.GetAuthToken();
                if (authToken) {
                    await this.checkTokenExpiryAndAuthorize(authToken);
                }
            }, 5000);
        }
    };
}
